import { GAME_LOCATIONS } from '../data/gameLocations';

const PENDING_KEY = 'nacanaca-pending-tournament';
const ACTIVE_KEY = 'nacanaca-active-tournament';

export function buildTournamentUrl(token) {
  return `${window.location.origin}/torneo?token=${encodeURIComponent(token)}`;
}

export function savePendingTournamentToken(token) {
  try {
    if (token) localStorage.setItem(PENDING_KEY, token);
  } catch {
    // Sin almacenamiento: el enlace sigue funcionando en esta visita.
  }
}

export function loadPendingTournamentToken() {
  try {
    return localStorage.getItem(PENDING_KEY) || '';
  } catch {
    return '';
  }
}

export function clearPendingTournamentToken() {
  try {
    localStorage.removeItem(PENDING_KEY);
  } catch {
    // Nada que limpiar.
  }
}

export function saveActiveTournament(entry) {
  try {
    if (entry) sessionStorage.setItem(ACTIVE_KEY, JSON.stringify(entry));
    else sessionStorage.removeItem(ACTIVE_KEY);
  } catch {
    // Sin almacenamiento de sesión: el juego no podrá arrancar el torneo.
  }
}

export function loadActiveTournament() {
  try {
    return JSON.parse(sessionStorage.getItem(ACTIVE_KEY) || 'null');
  } catch {
    return null;
  }
}

// La locación del torneo es una zona de juego; la ambientación visible es la
// primera del catálogo con esa zona (o el centro como respaldo).
export function sceneLocationIdForZone(zone) {
  const found = GAME_LOCATIONS.find((location) => location.gameZone === zone);
  return (found || GAME_LOCATIONS[0]).id;
}

export function resolveTournamentShareText(tournament) {
  const name = tournament?.name || 'el torneo';
  return `¡Únete al torneo "${name}" en La Maldición del Ñaca Ñaca! Tienes una sola partida para ganar.`;
}
